import * as React from "react";
import { Stack } from "@chakra-ui/react";

import SearchPerson from "components/Chakra/Icons/SearchPerson";

const PersonCircle: React.FC = () => (
  <Stack
    boxSize="32px"
    borderRadius="100%"
    bgColor="ud-primary-200"
    justify="center"
    align="center"
  >
    <SearchPerson boxSize="20px" fillWith="ud-primary" />
  </Stack>
);

export default PersonCircle;
